import { DirectSalesLineAllocation, DirectSalesLineObjective } from 'components/common/types/DirectSalesCampaign.types';
import { formatLineDataToAllocation } from 'utils/formatLineDataToAllocation';
import { EditableTargetField, AllocationField, RowDataItem } from './ObjectivesModal.types';

export const createRowData = (
  objectives: DirectSalesLineObjective[],
  lineAllocation: DirectSalesLineAllocation = {},
): RowDataItem[] => {
  if (!objectives?.length) return [];

  return objectives.map((objective) => {
    const budgetAllocation = formatLineDataToAllocation(lineAllocation || {}, objective.budget?.objectiveId ?? null);
    const framesAllocation = formatLineDataToAllocation(lineAllocation || {}, objective.frames?.objectiveId ?? null);
    const impressionsAllocation = formatLineDataToAllocation(
      lineAllocation || {},
      objective.impressions?.objectiveId ?? null,
    );

    return {
      objectiveGroupId: objective.objectiveGroupId,
      name: objective.name || '',
      budget: {
        value: objective.budget.value || undefined,
        greenTolerance: objective.budget.greenTolerance,
        orangeTolerance: objective.budget.orangeTolerance,
        objectiveId: objective.budget.objectiveId,
        priority: objective.budget.priority,
      },
      budgetAllocation,
      frames: {
        value: objective.frames.value || undefined,
        greenTolerance: objective.frames.greenTolerance,
        orangeTolerance: objective.frames.orangeTolerance,
        objectiveId: objective.frames.objectiveId,
        priority: objective.frames.priority,
      },
      framesAllocation,
      impressions: {
        value: objective.impressions.value || undefined,
        greenTolerance: objective.impressions.greenTolerance,
        orangeTolerance: objective.impressions.orangeTolerance,
        objectiveId: objective.impressions.objectiveId,
        priority: objective.impressions.priority,
      },
      impressionsAllocation,
      formats: objective.formats || [],
      locations: objective.locations || [],
      poi: objective.poi || [],
      tags: objective.tags || [],
      frameList: objective.frameList,
    };
  });
};

export const isEditableTargetField = (field: string): field is EditableTargetField => {
  return field === 'budget' || field === 'frames' || field === 'impressions';
};

export const getAllocationField = (field: EditableTargetField): AllocationField => {
  return `${field}Allocation` as AllocationField;
};

export const isFrameList = (value: unknown): value is RowDataItem['frameList'] => {
  return !!value && typeof value === 'object' && 'routeFrameCodes' in value && 'listFiles' in value;
};

export const hasFrameListData = (frameList: RowDataItem['frameList']): boolean => {
  if (!frameList) return false;
  return Boolean(
    frameList.routeFrameCodes?.length || frameList.listFiles?.length || frameList.mapRouteFrameCodes?.length,
  );
};
